import { Component, Input } from "@angular/core";

@Component({
  selector: "app-cab-loading",
  templateUrl: "./cab-loading.component.html",
  styleUrls: ["./cab-loading.component.scss"],
  standalone: true,
})
export class CabLoadingComponent {
  @Input() height = "500px";
}
